import { Outlet, useParams } from "react-router";
import { useFileProcessing } from "@/hooks/use-file-processing";
import { useAnalysisFollowsTheLibrary } from "@/hooks/use-novelty-analysis";

/**
 * The open draft, keyed on taskId so React fully remounts the stage panes between drafts.
 * It holds the task's stream once for every page it shows: the worker's runs reach the screen
 * only through it, and a page that held its own could forget to. It holds the watch that
 * reads the novelty analysis again when the prior art moves, for the same reason.
 */
export function KeyedV2Draft() {
  const { taskId } = useParams<{ taskId: string }>();
  useFileProcessing(taskId ?? null);
  useAnalysisFollowsTheLibrary(taskId);
  return <Outlet key={taskId} />;
}
